import { RouteConfig } from 'vue-router'

export const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/requests'
  },
  {
    path: '/schools',
    component: () => import('@/components/schools/View.vue'),
    meta: {
      title: 'Школы'
    }
  },
  {
    path: '/managers',
    component: () => import('@/components/managers/View.vue'),
    meta: {
      title: 'Менеджеры'
    }
  },
  {
    path: '/forms',
    component: () => import('@/modules/forms/components/ListView.vue'),
    meta: {
      title: 'Формы'
    }
  },
  {
    path: '/forms/:id',
    component: () => import('@/modules/forms/components/SingleView.vue'),
    meta: {
      title: 'Форма'
    }
  },
  {
    path: '/settings',
    component: () => import('@/components/settings/View.vue'),
    meta: {
      title: 'Настройки'
    }
  },
  {
    path: '/logs',
    component: () => import('@/modules/logs/components/ListView.vue'),
    meta: {
      title: 'Логи'
    }
  },
  {
    path: '/associations',
    component: () => import('@/modules/associations/components/ListView.vue'),
    meta: {
      title: 'Ассоциации'
    }
  },
  {
    path: '/requests',
    component: () => import('@/modules/requests/components/ListView.vue'),
    meta: {
      title: 'Заявки'
    }
  },
  {
    path: '/courses',
    component: () => import('@/modules/courses/components/ListView.vue'),
    meta: {
      title: 'Курсы'
    }
  }
]
